module.exports = __webpack_public_path__ + "static/media/Ramona Avenue, Albany, CA1.9e946d1c.jpg";